module.exports = __webpack_public_path__ + "img/Time_For_Christmas.bd712025.jpg";